import Title from './title'
import TitleIcon from './titleIcon'

const TitleContainer = ({ title, icon }) => {
  return (
    <div className="relative w-full h-fit gap-[10px] lg:gap-[40px] flex flex-col lg:flex-row items-center">
      <TitleIcon icon={icon} />
      <Title text={title} />
    </div>
  )
}

export default TitleContainer
